import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-consent-history-data',
  templateUrl: './consent-history-data.component.html',
  styleUrls: ['./consent-history-data.component.scss']
})
export class ConsentHistoryDataComponent implements OnInit {

  statusIcon: String;
  displayStatus: String;

  constructor() { }

  @Input()
  consentInfo;

  ngOnInit() {
    this.preapareDisplayData();
  }


  preapareDisplayData() {
    if(this.consentInfo.expireTime < new Date().toISOString()) {
      this.statusIcon = 'expired'
      this.displayStatus = "Expired";
      return;
    } 

    switch (this.consentInfo.eventType) {
      case 'CONSENT_REJECT':
        this.statusIcon = "declined"
        this.displayStatus = "Declined";
        return;
      case 'CONSENT_CONFIRMED':
        this.statusIcon = "accepted"
        this.displayStatus = "Accepted";
        return;
    }

    switch (this.consentInfo.status) {
      case 'PENDING':
        this.statusIcon = "pending"
        this.displayStatus = "Pending";
        return;
      case 'DECLINED':
        this.statusIcon = "declined"
        this.displayStatus = "Declined";
        return;
      case 'REVOKED':
        this.statusIcon = "revoked"
        this.displayStatus = "Revoked";
        return;
    }

    if(!this.statusIcon) {
      this.statusIcon = "accepted"
      this.displayStatus = "Accepted";
    }       
  }
}
